// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "d095db2a74c6b9363e08d9951826b57321b59941/" + chunkId + ".js";
};